import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cec79cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dialog-title" }, "分享商品清单", -1))
const _hoisted_3 = { class: "dialog-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dialog-info-title" }, "链接地址", -1))
const _hoisted_5 = { class: "dialog-edit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dialog-contents",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "info-url",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.copyurl) = $event))
        }, null, 512), [
          [_vModelText, _ctx.copyurl]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "dialog-edit-co dialog-edit-left",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["stop"]))
        }, "取消"),
        _createElementVNode("div", {
          class: "dialog-edit-co dialog-edit-right",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyInfo && _ctx.copyInfo(...args)))
        }, " 复制链接 ")
      ])
    ])
  ]))
}